import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import { injectedWallet, metaMaskWallet, walletConnectWallet } from '@rainbow-me/rainbowkit/wallets'
import { defineChain } from 'viem'

import { getActiveChain, getActiveChainId } from '../config/active'
import { buildWagmiTransports, getRpcUrl } from '../config/rpc'
import { WAGMI_DEFAULT_POLLING_INTERVAL_MS } from '../constants/rpcPolling'
import {
  getWalletConnectProjectId,
  isWalletConnectConfigured,
  WALLETCONNECT_PLACEHOLDER_PROJECT_ID,
} from '../domain/wallet/walletConnectProjectId'

const activeChain = getActiveChain()
const networkUrl = getRpcUrl(getActiveChainId())

export const infiniteCreativeChain = defineChain({
  id: activeChain.chainId,
  name: activeChain.displayName,
  nativeCurrency: activeChain.nativeCurrency,
  rpcUrls: {
    default: { http: [networkUrl] },
  },
  blockExplorers: {
    default: {
      name: `${activeChain.displayName} Explorer`,
      url: activeChain.explorer.baseUrl,
    },
  },
})

const walletConnectProjectId = getWalletConnectProjectId()
const walletConnectEnabled = isWalletConnectConfigured()

/** Sin WC configurado: solo injected/MetaMask (evita init Reown con projectId placeholder). */
const rainbowWallets = walletConnectEnabled
  ? [
      {
        groupName: 'Popular',
        wallets: [metaMaskWallet, walletConnectWallet],
      },
    ]
  : [
      {
        groupName: 'Popular',
        wallets: [metaMaskWallet, injectedWallet],
      },
    ]

/**
 * RainbowKit + wagmi: conectores recomendados; WalletConnect solo si hay project ID válido.
 * Ver `docs/500-guias/reown-walletconnect-operacion.md`.
 */
export const wagmiConfig = getDefaultConfig({
  appName: "Don't Panic DEX",
  projectId: walletConnectEnabled ? walletConnectProjectId : WALLETCONNECT_PLACEHOLDER_PROJECT_ID,
  wallets: rainbowWallets,
  chains: [infiniteCreativeChain],
  transports: buildWagmiTransports([activeChain]),
  pollingInterval: WAGMI_DEFAULT_POLLING_INTERVAL_MS,
  ssr: false,
})

export { walletConnectEnabled, walletConnectProjectId }
